import React from "react";
import { Typography, Container } from "@mui/material";

const MinorSurgeries = () => {
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom sx={{ color: '#ED1C24' }}>
        Minor Surgeries
      </Typography>

      <Typography variant="body1" paragraph>
        At VEM Plus Urgent Care, we understand that certain medical conditions require immediate
        surgical attention but do not need the facilities of a full scale hospital. Our
        <strong> Minor Surgeries</strong> service is designed to provide quick, effective, and
        affordable treatment for such cases all in a safe, clean, and fully equipped clinical
        environment.
      </Typography>

      <Typography variant="body1" paragraph>
        Our experienced healthcare professionals perform a variety of outpatient procedures for
        non life threatening injuries and conditions. These surgeries are typically done under
        local anesthesia, allowing patients to walk in, get treated, and return home the same day.
      </Typography>

      <Typography variant="body1" paragraph>
        <strong>Common Minor Surgical Procedures We Offer:</strong>
      </Typography>

      <Typography
        variant="body2"
        component="ul"
        gutterBottom
        sx={{ pl: 3, listStyleType: 'disc',marginBottom: '0.5rem'  }}
      >
        <li>
          <strong>Wound Cleaning & Suturing:</strong> Immediate care for cuts, lacerations, and injuries to
          prevent infection and minimize scarring.
        </li>
        <li>
          <strong>Abscess Incision & Drainage:</strong> Safe relief from painful infections through quick
          drainage and proper aftercare.
        </li>
        <li>
          <strong>Foreign Body Removal:</strong> Extraction of splinters, glass, or debris lodged in the skin
          or soft tissue.
        </li>
        <li>
          <strong>Skin Lesion & Cyst Removal:</strong> Removal of benign skin growths, moles, or cysts causing
          discomfort or cosmetic concerns.
        </li>
        <li>
          <strong>Minor Fracture Care:</strong> Splinting and basic orthopedic support for uncomplicated
          fractures or dislocations.
        </li>
      </Typography>


      <Typography variant="body1" paragraph>
        Our urgent care setup also offers on site <strong>X-ray and laboratory services</strong>,
        enabling accurate diagnosis before and after minor surgical procedures. This means you
        receive the complete treatment from examination and imaging to the procedure and follow up
        all in one visit.
      </Typography>

      <Typography variant="body1" paragraph>
        By choosing VEM Plus Urgent Care for minor surgeries, you avoid the high costs and long waits
        of hospital emergency rooms, while still receiving expert, compassionate care. Whether for
        adults, children, or seniors, we make sure every patient leaves feeling better, safer, and
        well informed about their recovery process.
      </Typography>
    </Container>
  );
};



export default MinorSurgeries;
